module.exports = __webpack_public_path__ + "static/media/CircularPro-Bold.acc6e43e.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/CircularPro-Bold.eot
// module id = 108
// module chunks = 0